import React, {Component} from "react";

export class KlaviyoLogo extends Component {
    getHeight() {
        if(this.props.height)
            return this.props.height;
        return 30;
    }

    getWidth() {
        if(this.props.width)
            return this.props.width;
        return 30;
    }

    getHSpace() {
        if(this.props.hspace !== undefined)
            return this.props.hspace;
        return 10;
    }

    getVSpace() {
        if(this.props.vspace !== undefined)
            return this.props.vspace;
        return 10;
    }

    render() {
        const style = {
            ...this.props.styles,
            marginRight: this.getHSpace(),
            marginTop: this.getVSpace(),
            marginBottom: this.getVSpace(),
        };

        return (
            <svg
                viewBox="0 0 800 800"
                height={this.getHeight()}
                width={this.getWidth()}
                style={style}
                aria-label="Klaviyo"
            >
                <rect width="800" height="800" rx="160" fill="#29323B"/>
                <path
                    d="M620 560L480 400L620 240H500L400 360L300 240H180L320 400L180 560H300L400 440L500 560H620Z"
                    fill="#FFFFFF"
                />
            </svg>
        );
    }
}
